import React from 'react';
import styled from 'styled-components';

import { font } from '../utils/fontSize';
import { useTheme } from '../contexts/ThemeProvider';
import { profile } from '../data/profile';

const Nav = ({ visible, isBurger, onBurgerChange, navItems, activeSection, onNavigate }) => {
	const color = useTheme();

	const links = navItems.map((item) => (
		<li key={item.id}>
			<button className={activeSection === item.id ? 'active' : ''} onClick={() => onNavigate(item.id)}>
				{item.label}
			</button>
		</li>
	));

	return (
		<NavContainer color={color.color} showBurgerMenu={isBurger} showNav={visible}>
			<h2>{profile.shortName}</h2>
			<ul className="nav-container">{links}</ul>
			<label className="burger" htmlFor="burger">
				<input type="checkbox" id="burger" checked={isBurger} onChange={(e) => onBurgerChange(e.target.checked)} />
				<span></span>
				<span></span>
				<span></span>
			</label>

			<div className="burger-menu">
				<ul>{links}</ul>
			</div>
		</NavContainer>
	);
};

export default Nav;

const NavContainer = styled.div`
	background-color: ${({ color }) => color.background};
	color: ${({ color }) => color.text};
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 7rem;
	width: 100vw;
	position: sticky;
	padding: 1rem 3rem;
	top: 0;
	z-index: 10;
	text-transform: uppercase;
	opacity: ${({ showNav }) => (showNav ? '1' : '0')};
	transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
	h2 {
		font-size: ${font.l1};
		letter-spacing: 2.5px;
		color: ${({ color }) => color.text};
		display: inline-block;
		font-weight: 800;
		transform: ${({ showNav }) => (showNav ? 'translateY(0)' : 'translateY(-100%)')};
		opacity: ${({ showNav }) => (showNav ? '1' : '0')};
		transition: 0.3s ease-in-out, opacity 0.3s ease-in-out;
		&:hover,
		&:active {
			cursor: pointer;
			transform: translateY(-3px);
			filter: ${({ color }) =>
		color.isLightMode
			? 'drop-shadow(10px 5px 40px rgb(0, 0, 0))'
			: 'drop-shadow(10px 5px 40px rgb(255, 255, 255))'};
		}
	}

	ul {
		display: flex;
		align-items: center;
		justify-content: space-evenly;
		gap: 4rem;
		transform: ${({ showNav }) => (showNav ? 'translateY(0)' : 'translateY(-100%)')};
		opacity: ${({ showNav }) => (showNav ? '1' : '0')};
		transition: 0.3s ease-in-out, opacity 0.3s ease-in-out;

		li {
			list-style: none;

			button {
				font-family: 'SHPinscher';
				font-size: 1.5rem;
				font-weight: 800;
				text-transform: uppercase;
				cursor: pointer;
				letter-spacing: 5.5px;
				font-weight: 800;
				position: relative;
				border: none;
				background: none;
				text-decoration: none;
				text-transform: uppercase;
				transition-timing-function: cubic-bezier(0.15, 0.8, 0.15, 1);
				transition-duration: 400ms;
				transition-property: color;
				color: ${({ color }) => color.label};

				&.active {
					color: ${({ color }) => color.primary};

					&:after {
						width: 100%;
						left: 0%;
					}
				}

				&:hover {
					color: ${({ color }) => color.primary};
				}

				&:active:after,
				&:hover:after {
					width: 100%;
					left: 0%;
				}

				&:after {
					content: '';
					pointer-events: none;
					bottom: -2px;
					left: 50%;
					position: absolute;
					width: 0%;
					height: 2px;
					background-color: ${({ color }) => color.primary};
					transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
					transition-duration: 400ms;
					transition-property: width, left;
				}
			}
		}
	}

	.burger {
			position: absolute;
			top: 2.5rem;
			right: 1.5rem;
			width: 30px;
			height: 20px;
			background: transparent;
			cursor: pointer;
			z-index: 100;
			display:none;
			opacity: 0;
			transition: .25s ease-in-out;
		}

		.burger input {
			display: none;
		}

		.burger span {
			display: block;
			position: absolute;
			height: 2px;
			width: 100%;
			background: ${({ color }) => color.text};
			border-radius: 9px;
			opacity: 1;
			left: 0;
			transform: rotate(0deg);
			transition: .25s ease-in-out;
		}

		.burger span:nth-of-type(1) {
			top: 0px;
			transform-origin: left center;
		}

		.burger span:nth-of-type(2) {
			top: 50%;
			transform: translateY(-50%);
			transform-origin: left center;
		}

		.burger span:nth-of-type(3) {
			top: 100%;
			transform-origin: left center;
			transform: translateY(-100%);
		}

		.burger input:checked ~ span:nth-of-type(1) {
			transform: rotate(45deg);
			top: 0px;
			left: 5px;
		}

		.burger input:checked ~ span:nth-of-type(2) {
			width: 0%;
			opacity: 0;
		}

		.burger input:checked ~ span:nth-of-type(3) {
			transform: rotate(-48deg);
			top: 22px;
			left: 4px;
		}

		.burger-menu{
			position: absolute;
			display:flex;
			align-items:center;
			justify-content:center;
			top: 0;
			left: 0;
			height: 100vh;
			width: 100vw;
			background-color: ${({ color }) => color.backgroundLowOpac};
			transition: .3s ease-out transform;
			transform: translateX(100%);
			transform: ${({ showBurgerMenu }) => (!showBurgerMenu ? 'translateX(100%)' : 'translateX(0)')};

			ul {
			display: flex;
			align-items: center;
			justify-content: space-evenly;
			flex-direction: column;
			gap: 4rem;
			transform: ${({ showNav }) => (showNav ? 'translateY(0)' : 'translateY(-100%)')};
			opacity: ${({ showNav }) => (showNav ? '1' : '0')};
			transition: 0.3s ease-in-out, opacity 0.3s ease-in-out;

			li {
				list-style: none;

				button {
					font-family: 'SHPinscher';
					font-size: 1.5rem;
					font-weight: 800;
					text-transform: uppercase;
					cursor: pointer;
					letter-spacing: 5.5px;
					font-weight: 800;
					position: relative;
					border: none;
					background: none;
					text-decoration: none;
					text-transform: uppercase;
					transition-timing-function: cubic-bezier(0.15, 0.8, 0.15, 1);
					transition-duration: 400ms;
					transition-property: color;
					color: ${({ color }) => color.label};

					&.active {
						color: ${({ color }) => color.primary};

						&:after {
							width: 100%;
							left: 0%;
						}
					}

					&:hover {
						color: ${({ color }) => color.primary};
					}

					&:active:after,
					&:hover:after {
						width: 100%;
						left: 0%;
					}

					&:after {
						content: '';
						pointer-events: none;
						bottom: -2px;
						left: 50%;
						position: absolute;
						width: 0%;
						height: 2px;
						background-color: ${({ color }) => color.primary};
						transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
						transition-duration: 400ms;
						transition-property: width, left;
					}
				}
			}
		}
		}

	@media (max-width: 768px) {
		opacity: 1;
	}
	@media (max-width: 1024px){
		/* display: none; */
		width: 100vw;
		padding: 2rem;

		.burger{
			display: ${({ showNav }) => (showNav ? 'block' : 'none')};
			opacity: ${({ showNav }) => (showNav ? '1' : '0')};
		}

		.nav-container{
			li{
				display:none;
			}
		}
	}
`;
